export function getCurrentWeekNumber(culture: string): number {
  // Normalize culture to lowercase for easy matching
  const c = culture.toLowerCase();

  // US explicitly
  if (c.startsWith('en-us')) {
    return getCurrentUsWeekNumber();
  }

  // Default use ISO 8601 (European)
  return getCurrentEuropeanWeekNumber();
}

function getCurrentEuropeanWeekNumber(): number {
  const now: Date = new Date();

  // Create a UTC date (ignores time zone offsets)
  const date: Date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));

  // Shift the date so that "date" becomes the Thursday of the current week
  // (ISO 8601 defines week 1 as the week with the year's first Thursday)
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));

  // January 1 of the same year, in UTC
  const yearStart: Date = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));

  // difference in days from year start, divided by 7, rounded up result = ISO week number
  const weekNo: number = Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);

  return weekNo;
}

function getCurrentUsWeekNumber(): number {
  const now: Date = new Date(2025, 8, 8);

  // Start of year (Jan 1, same year)
  const yearStart: Date = new Date(now.getFullYear(), 0, 1);

  // Difference in days since Jan 1
  const days = Math.floor((now.getTime() - yearStart.getTime()) / 86400000);

  // US week number: divide by 7, add 1
  return Math.floor(days / 7) + 1;
}
